export const CookieKey = Object.freeze({
  TOKEN: "@vaidevan-pax-Tk",
  REMEMBER_ME: "@vaidevan-pax-remember-me",
  DEVICE_INFO_SAVED_KEY: "@vaidevan-pax-device-data-saved",
  NEXT_RESEND_SMS_AVAILABLE_DATE_KEY:
    "@vaidevan-pax-next-resend-sms-available-date",
  REFERRAL_CODE: "@vaidevan-pax-referral-code"
});
